export const getMadeToOrderText = function (isMadeToOrder, estimatedShipping) {
    const text = {}
    if (isMadeToOrder) text.main = 'Made to Order'
    if (estimatedShipping) {
        text.main = 'Ships in '
        text.shipTime = shippingText(estimatedShipping)
    }

    return text
}
export const getShippingMessage = function (shipping, sameDayShippingMsg) {
    let msg = !shipping.sameDay ? 'Free' : 'Free Same Day'
    if (shipping.sameDay && sameDayShippingMsg) msg = sameDayShippingMsg
    if (shipping.isFreight) msg = msg + ' Freight'
    msg = msg + ' Shipping'

    return msg
}
export const getTimeRemainingText = function (
    startDayOfWeek,
    endDayOfWeek,
    cutoffTime,
    hasEstimatedDelivery
) {
    const today = new Date()
    const todayMS = today.getTime()

    // create garbage date obj from api datetime to capture time
    const apiCutoffTime = new Date(cutoffTime)
    const cutoff = new Date() // always make cutoff date today

    // set cutoff's time to API cutoff time
    cutoff.setHours(apiCutoffTime.getHours())
    cutoff.setMinutes(apiCutoffTime.getMinutes())
    cutoff.setSeconds(apiCutoffTime.getSeconds())

    const cutoffMS = cutoff.getTime()
    const startDay = getNumericDay(startDayOfWeek)
    const endDay = getNumericDay(endDayOfWeek)
    const beforeCutoffTime = todayMS < cutoffMS
    const betweenStartAndEndDays = today.getDay() >= startDay && today.getDay() <= endDay

    if (beforeCutoffTime && betweenStartAndEndDays) {
        // show countdown
        const countdown = cutoffMS - todayMS
        const hours = Math.floor(countdown / 1000 / 60 / 60)
        const minutes = Math.floor(countdown / 1000 / 60) % 60
        const seconds = Math.floor(countdown / 1000) % 60

        let hoursString = ''
        if (hours === 0) hoursString = ''
        else if (hours > 9) hoursString = `${hours}h`
        else hoursString = `0${hours}h`

        const orderText = !hasEstimatedDelivery
            ? 'Ships FREE today if ordered within '
            : 'Ships FREE! Order within '
        return {
            orderText,
            hours: hoursString,
            minutes: minutes > 9 ? `${minutes}m` : `0${minutes}m`,
            seconds: seconds > 9 ? `${seconds}s` : `0${seconds}s`,
        }
    }

    if (
        // if during week and a day or more before end day
        (betweenStartAndEndDays && today.getDay() <= endDay - 1) ||
        // or not during week and day before start day
        (!betweenStartAndEndDays && today.getDay() === startDay - 1)
    ) {
        const orderText = !hasEstimatedDelivery
            ? 'Order today, ships FREE tomorrow'
            : 'Ships FREE!  Order today'
        return {
            orderText,
        }
    }

    return {}
}

export const sameDayShippingDisplayMixin = {
    computed: {
        sameDayShippingBackgroundColor() {
            return this.$config.runtime.theme.sameDayShipping.mode === 'RAPIDSHIP'
                ? 'bg-success'
                : 'bg-info'
        },
        sameDayShippingBorderColor() {
            return this.$config.runtime.theme.sameDayShipping.mode === 'RAPIDSHIP'
                ? 'border-success'
                : 'border-info'
        },
        sameDayShippingTextColor() {
            return this.$config.runtime.theme.sameDayShipping.mode === 'RAPIDSHIP'
                ? 'text-success'
                : 'text-info'
        },
        sameDayShippingText() {
            return this.$config.runtime.theme.sameDayShipping.mode === 'RAPIDSHIP'
                ? 'RapidShip'
                : 'QuickShip'
        },
    },
}

/**
 *
 * @param {object} shippingData
 * @param {boolean} includeDate - Used by Segment but front end needs text and date separated
 * @returns
 */
export const getEddText = function (shippingData, includeDate = false) {
    if (!shippingData.estimatedDeliveryDate) return

    let text = !shippingData.sameDay ? 'Arrives' : 'arrives'
    if (includeDate) text = text + ' ' + getEddDate(shippingData)
    return text
}

export const getEddDate = function (shippingData) {
    if (!shippingData.estimatedDeliveryDate) return

    const { min, max } = shippingData.estimatedDeliveryDate
    // const min = '2021-01-02T13:00:00.000Z'
    // const max = '2021-01-02T13:00:00.000Z'

    if (min === max) {
        const d = getDateObject(min)
        return `${d.day}, ${d.monthStr} ${d.date}${d.dateSuffix}`
    } else {
        const minD = getDateObject(min)
        const maxD = getDateObject(max)
        const maxMonthString = minD.month !== maxD.month ? maxD.monthStr + ' ' : ''
        return `${minD.monthStr} ${minD.date}${minD.dateSuffix} - ${maxMonthString}${maxD.date}${maxD.dateSuffix}`
    }
}

export const getOrdinal = function (day) {
    if (day > 3 && day < 21) return 'th'
    if (day % 10 === 1) return 'st'
    if (day % 10 === 2) return 'nd'
    if (day % 10 === 3) return 'rd'
    return 'th'
}

function shippingText(estimatedShipping) {
    const minShipUnit = shipTimeUnit(estimatedShipping.min.unit, estimatedShipping.min.amount)
    const maxShipUnit = shipTimeUnit(estimatedShipping.max.unit, estimatedShipping.max.amount)
    if (
        estimatedShipping.min.unit === estimatedShipping.max.unit &&
        estimatedShipping.min.amount === estimatedShipping.max.amount
    )
        return `${estimatedShipping.max.amount} ${maxShipUnit}`
    if (estimatedShipping.min.unit === estimatedShipping.max.unit)
        return `${estimatedShipping.min.amount} - ${estimatedShipping.max.amount} ${maxShipUnit}`
    return `${estimatedShipping.min.amount} ${minShipUnit} - ${estimatedShipping.max.amount} ${maxShipUnit}`
}

function shipTimeUnit(shipUnit, shipTime) {
    let unit
    if (shipUnit === 'WEEKS') unit = 'Week'
    if (shipUnit === 'DAYS') unit = 'Day'
    return shipTime > 1 ? `${unit}s` : unit
}

function getNumericDay(day) {
    return ['sun', 'mon', 'tue', 'wed', 'thu', 'fri', 'sat'].indexOf(day)
}

function getDateObject(date) {
    const d = new Date(date)
    return {
        month: d.getUTCMonth(),
        monthStr: getFullNameMonth(d.getUTCMonth()),
        day: getFullNameDay(d.getUTCDay()),
        date: d.getUTCDate(),
        dateSuffix: getOrdinal(d.getUTCDate()),
    }
}

function getFullNameDay(day) {
    const days = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday']
    return days[day] || ''
}

function getFullNameMonth(month) {
    const months = [
        'Jan',
        'Feb',
        'Mar',
        'Apr',
        'May',
        'Jun',
        'Jul',
        'Aug',
        'Sep',
        'Oct',
        'Nov',
        'Dec',
    ]
    return months[month] || ''
}
